import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { id: 'Artboard-32' }),
  React.createElement('path', { id: 'Artboard-32-2', 'data-name': 'Artboard-32' }),
  React.createElement('path', { d: 'M26 4.39H6A2.65 2.65 0 0 0 3.35 7v18A2.65 2.65 0 0 0 6 27.69h20A2.65 2.65 0 0 0 28.65 25V7A2.65 2.65 0 0 0 26 4.39zm-6.65 1.3v20.7h-6.7V5.69zM4.65 25V7A1.36 1.36 0 0 1 6 5.69h5.35v20.7H6A1.35 1.35 0 0 1 4.65 25zm22.7 0A1.35 1.35 0 0 1 26 26.39h-5.35V5.69H26A1.36 1.36 0 0 1 27.35 7z' }),
  React.createElement('path', { d: 'M5.71 8.56h4.57v1.3H5.71zM5.71 12.02h4.57v1.3H5.71zM5.71 15.47h4.57v1.3H5.71zM21.71 8.56h4.57v1.3h-4.57zM21.71 12.02h4.57v1.3h-4.57zM21.71 15.47h4.57v1.3h-4.57zM21.71 18.93h4.57v1.3h-4.57zM13.71 8.56h4.57v1.3h-4.57zM13.71 12.02h4.57v1.3h-4.57z' })
));